import { Component } from '@angular/core';

@Component({
  selector: 'app-error403',
  templateUrl: './error403.component.html',
  styleUrl: './error403.component.css',
  standalone: false
})
export class Error403Component {

}
